import { render, staticRenderFns } from "./classEditDialog.vue?vue&type=template&id=ffe4a722&scoped=true"
import script from "./classEditDialog.vue?vue&type=script&lang=js"
export * from "./classEditDialog.vue?vue&type=script&lang=js"
import style0 from "./classEditDialog.vue?vue&type=style&index=0&id=ffe4a722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe4a722",
  null
  
)

export default component.exports